import styled from 'styled-components';

export const StyledRow = styled.div<{ $noBorder?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  ${(props) => (props.$noBorder ? '' : `border-bottom: 1px solid ${props.theme.color.borderColor}`)};
`;

export const StyledPersonIndicator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StyledDetails = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5rem;
  & > * {
    flex: 1;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const StyledListItem = styled.li<{ $isDetail?: boolean }>`
  padding: 0.5rem;
  font-weight: ${(props) => (props.$isDetail ? '400' : '600')};
`;
